import { FallbackError } from "@core/domain/errors/fallback.error";
import { PestDatasource } from "@station/data/datasources/pest.datasource";
import type { Pests } from "@station/domain/models/pest.model";
import type { PestRepository } from "@station/domain/repositories/pest.repository";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class PestImplRepository implements PestRepository {
    constructor(
        @inject(PestDatasource)
        private readonly pestDatasource: PestDatasource,
    ) {}

    getAllPest(stationId: string): ResultAsync<Pests, FallbackError> {
        return this.pestDatasource.fetchAllPest(stationId);
    }
}
